import { LinkInfoType, MilestoneType } from '../../../models';
import { BorderType, DateWithTimezones, SCode } from '../../../../common';

export class ShipmentWaybillMilestoneModel {
  active: boolean;
  actualDate: DateWithTimezones | null = null;
  address: string;
  code: SCode;
  description: string;
  descriptionActive: boolean;
  estimatedDate: DateWithTimezones | null = null;
  index: number;
  linkInfoType: LinkInfoType;
  linkType: BorderType;
  major: boolean;
  passed: boolean;
  secondarySource: boolean;
  title: string;
  titleAddress: string;
  type: MilestoneType;
  transportName: string;
}
